// Responsive layout (decision 0046: "phones play in landscape, with a rotate prompt in portrait"; screens placed
// inside the safe areas). The safe-area insets come from CSS `env(safe-area-inset-*)` (the page needs
// `viewport-fit=cover`); each is also a custom property (`--rpg-safe-top` …) so a game or a test can override it.

/** Should the rotate prompt show? Phones only, when the viewport is taller than wide. */
export function needsRotatePrompt(o: { phone: boolean; width: number; height: number }): boolean {
  return o.phone && o.height > o.width;
}

/** The safe-area insets the UI root is laid out inside, px, read from its computed custom properties. */
export function safeInsets(root: Element): { top: number; right: number; bottom: number; left: number } {
  const cs = getComputedStyle(root);
  const px = (name: string): number => parseFloat(cs.getPropertyValue(name)) || 0;
  return { top: px("--rpg-safe-top"), right: px("--rpg-safe-right"), bottom: px("--rpg-safe-bottom"), left: px("--rpg-safe-left") };
}
